import React, { useState, useEffect } from "react";
import Header from "../Header";
import Footer from "../Footer";
import "../../assets/css/Jobs.css";
import { FaHome, FaRegFileAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { fetchJobs } from "./fetchJobs";
import { fetchHelloWorkJobs } from "./fetchHelloWorkJobs";


const JobOffers = () => {
  const [jobs, setJobs] = useState([]);
  const [error, setError] = useState(null);
  const [visibleCount, setVisibleCount] = useState(4); 
  const [loading, setLoading] = useState(true); // Add loading state
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const getJobs = async () => {
      setLoading(true); // Set loading to true when fetching starts
      try {
        const internalJobs = await fetchJobs();
        const activeJobs = internalJobs
          .filter((job) => job.statut === "active")
          .map(job => ({
            ...job,
            date: new Date(job.created_at), 
          }));
  
        const helloWorkJobs = await fetchHelloWorkJobs();
        const formattedHelloWorkJobs = helloWorkJobs.map(job => ({
          id: `hw-${job.AdvertiseId}`,
          intitule: job.NameAdvertise,
          localisation: job.City,
          salaire_annuel: job.MaxRemuneration,
          teletravail: job.TeleworkRate?.toLowerCase().includes("oui") || job.IsTelework,
          type_id: job.JobContract,
          posted: new Date(job.CreateDate).toLocaleDateString("fr-FR"),
          date: new Date(job.CreateDate), 
          external: true,
          link: job.LinkPage,
        }));
  
        const mergedJobs = [...activeJobs, ...formattedHelloWorkJobs];
        mergedJobs.sort((a, b) => b.date - a.date);
        setJobs(mergedJobs);
      } catch (err) {
        console.error(err);
        setError("Échec de chargement des offres.");
      } finally {
        setLoading(false); // Set loading to false when done
      }
    };
  
    getJobs();
  }, []);

  const viewJob = (jobId) => {
    navigate(`${jobId}`);
  };

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 4);
  };

  if (loading) return (
    <div className="d-flex flex-column justify-content-center align-items-center" 
         style={{ minHeight: '80vh' }}>
      <div className="position-relative">
        <div className="spinner-container">
          <div className="outer-circle"></div>
          <div className="inner-circle"></div>
          <div className="icon-container">
            <i className="fas fa-briefcase text-primary" style={{ fontSize: '1.5rem' }}></i>
          </div>
        </div>
      </div>
      <div className="mt-4 text-primary">
        <span className="loading-text fw-bold">Chargement des offres</span>
        <span className="loading-dots"></span>
      </div>
      <style>
        {`
          .spinner-container {
            position: relative;
            width: 100px;
            height: 100px;
          }
          .outer-circle {
            position: absolute;
            width: 100%;
            height: 100%;
            border: 4px solid #e9ecef;
            border-top: 4px solid #0d6efd;
            border-radius: 50%;
            animation: spin 1.5s linear infinite;
          }
          .inner-circle {
            position: absolute;
            top: 15%;
            left: 15%;
            width: 70%;
            height: 70%;
            background: #fff;
            border-radius: 50%;
            box-shadow: 0 4px 15px rgba(0,0,0,0.1);
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .icon-container {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            animation: pulse 1.5s ease-in-out infinite;
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes pulse {
            0% { transform: translate(-50%, -50%) scale(1); }
            50% { transform: translate(-50%, -50%) scale(1.2); }
            100% { transform: translate(-50%, -50%) scale(1); }
          }
          .loading-text {
            font-size: 1.2rem;
            letter-spacing: 0.5px;
          }
          .loading-dots::after {
            content: '';
            animation: dots 1.5s infinite;
          }
          @keyframes dots {
            0% { content: ''; }
            25% { content: '.'; }
            50% { content: '..'; }
            75% { content: '...'; }
            100% { content: ''; }
          }
        `}
      </style>
    </div>
  );

  if (error) return <p className="text-center text-danger mt-5">{error}</p>;


  return (
    <div>
      <Header />
      <h1 className="text-center mb-5 mt-5">Nos Offres d'emploi</h1>
      <div className="container p-5 bg-light mb-5 rounded-5">
        <h3>
          <strong>{jobs.length} Offres</strong>
        </h3>
        <div className="mb-4">
          <input
            type="text"
            className="form-control"
            placeholder="Rechercher un poste ou une localisation..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
          />
        </div>

        <div className="row">
        {jobs
          .filter((job) =>
            job.intitule.toLowerCase().includes(searchTerm) ||
            job.localisation.toLowerCase().includes(searchTerm)
          )
          .slice(0, visibleCount)
          .map((job) => (

            <div className="col-md-6 mb-4" key={job.id}>
              <div className="card h-100 shadow-sm p-3">
                <div className="card-body">
                  <h5 className="card-title">{job.intitule}</h5>
                  <p className="card-subtitle text-muted">{job.localisation}</p>
                  <p className="text-primary job-salary">{job.salaire_annuel}€</p>
                  <p>
                    <FaHome /> <strong>Télétravail:</strong> {job.teletravail === 1 ? "Oui" : "Non"}
                  </p>
                  <p>
                    <FaRegFileAlt /> <strong>Contrat:</strong> {job.type_id}
                  </p>
                  <p className="text-muted">
                    <small>{job.posted}</small>
                  </p>
                  <button className="voir-btn" onClick={() => viewJob(job.id)}>
                    Voir l'offre
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Voir Plus Button - Shows only if there are more jobs to load */}
        {visibleCount < jobs.length && (
          <div className="text-center mt-4">
            <button className="voir-btn" onClick={handleShowMore}>
              Voir Plus
            </button>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default JobOffers;


